import { ArgumentError } from '../utils/errors';
import { BaseAPIModel, fetcher } from '@weezevent/weezjs-core';

export default class FeatureFlagsModel extends BaseAPIModel {
    fields() {
        return {
            value: {},
            key: { primaryKey: true }
        };
    }

    /**
     * Save item to API
     */
    save(...args) {
        return this.constructor.save(this, ...args);
    }

    static save(objects, ...args) {
        let data = objects.toAPI();
        let url = this.getListUrl(...args);

        return fetcher.post(url, { data });
    }

    delete(args, data) {
        let url = this.constructor.getListUrl(args);

        return fetcher.delete(`${url}/${data.key}`, { data });
    }

    static list(item) {
        return item;
    }

    static listUrl({ organizationId, eventId }) {
        if (!organizationId) {
            throw new ArgumentError(`[Model][FeatureFlags] organizationId is mandatory`);
        }

        if (eventId) {
            return `/ticket/organizations/${organizationId}/events/${eventId}/feature_flags`;
        }

        return `/ticket/organizations/${organizationId}/feature_flags`;
    }
}
